import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const STORAGE_KEY = 'accio3d.agent.sidebar';

interface SidebarState {
  open: boolean;
}

/* Whether the agent panel is showing, remembered for the tab's lifetime */
const useStore = create<SidebarState>()(
  persist(() => ({ open: false }), {
    name: STORAGE_KEY,
    storage: createJSONStorage(() => sessionStorage),
  }),
);

export function setSidebarOpen(next: boolean): void {
  useStore.setState({ open: next });
}

export function useSidebarOpen(): boolean {
  return useStore((state) => state.open);
}

export function resetSidebarStore(): void {
  useStore.persist.clearStorage();
  useStore.setState({ open: false });
}
